import React, { useState } from "react";
import { Form, Button, Card, Row, Col, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BuzonRegistro.css"; // Estilos específicos para Solicitudes
import FirmaElectronica from "../FirmaElectronica";
import Header from "../Components/Header";
import 'bootstrap-icons/font/bootstrap-icons.css';

const BuzonRegistro = () => {
  const [destinatario, setDestinatario] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [descripcion, setDescripcion] = useState("");

  const [signedFile, setSignedFile] = useState(null);

  const handleFileSigned = (fileBase64) => {
    setSignedFile(fileBase64);
    // console.log("Documento firmado recibido:", fileBase64);
  };

  const handleArchivoChange = (e) => {
    const file = e.target.files[0];
    setArchivo(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!signedFile) {
      alert("Por favor, firma el documento antes de enviarlo.");
      return;
    }
    // Aquí se enviaría el documento firmado al servidor
    // console.log("Solicitud enviada con documento firmado:", signedFile);
    alert("Solicitud enviada correctamente.");

    // console.log("Destinatario:", destinatario);
    // console.log(
    //   "Archivo:",
    //   archivo ? archivo.name : "No se seleccionó archivo"
    // );
    // console.log("Descripción:", descripcion);
    // // alert("Solicitud enviada correctamente");
  };

  return (
    <div className="d-flex flex-column">
      <Header></Header>
      <main className="flex-grow-1">
      <Container fluid className="py-3 px-4">
      <h4 className="section-title mt-2 mb-2"><i className="bi bi-inbox text-primary me-2"></i>Buzón de Registro</h4>
      <p className="text-muted mb-4">
        Desde aquí puede presentar un documento oficial dirigido a la administración,
        adjuntando el archivo y firmándolo electrónicamente.
      </p>
      <Card className="p-4 shadow-sm">
        <Card.Body>
          <Card.Subtitle className="mb-3 text-muted">
            Accedió al registro a las {new Date().toLocaleTimeString()} del{" "}
            {new Date().toLocaleDateString()}.
          </Card.Subtitle>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="destinatario">
                  <Form.Label>Destinatario</Form.Label>
                  <Form.Select
                    value={destinatario}
                    onChange={(e) => setDestinatario(e.target.value)}
                  >
                    <option value="">Seleccione el destinatario</option>
                    <option value="Secretaría">Secretaría</option>
                    {/* <option value="Dirección">Dirección</option> */}
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Seleccione el destinatario.
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}></Col>
            </Row>
            <FirmaElectronica onFileSigned={handleFileSigned} />
          </Form>
        </Card.Body>
      </Card>
      </Container>
      </main>
    </div>
  );
};

export default BuzonRegistro;
